import fetch from '../utils/fetch';

// 查询设备类型,区域类型,家居类型
export function getDeviceType() {
    return fetch({
        method: 'GET',
        url: 'increase/getDeviceTypeList',
    })
}

// 智能平台添加安装设备工单
export function addDevice(data) {
  return fetch({
    method: 'POST',
    url: 'increase/orderForStock',
    data
  })
}

// 智能平台添加安装智能家居工单
export function addFurniture(data) {
  return fetch({
    method: 'POST',
    url: 'increase/orderForSmartHome',
    data
  })
}

// 智能平台添加安装智能家居工单
export function getOrderList(params) {
  return fetch({
    method: 'GET',
    url: 'increase/getOrderList',
    params
  })
}

// 更新智能状态
export function updateIntellectStatus(params) {
  return fetch({
    method: 'GET',
    url: 'increase/updateIntellectStatus',
    params
  })
}

///increase/reOrder
export function reOrder(params) {
  return fetch({
    method: 'GET',
    url: 'increase/reOrder',
    params
  })
}

///increase/getWorkOrderByFid
export function getWorkOrderByFid(params) {
  return fetch({
    method: 'GET',
    url: 'increase/getWorkOrderByFid',
    params
  })
}
///houseInfo/parentListNoPage

export function parentListNoPage(params) {
  return fetch({
    method: 'GET',
    url: 'houseInfo/parentListNoPage',
    params
  })
}
///houseInfo/subList
export function subList(params) {
  return fetch({
    method: 'GET',
    url: 'houseInfo/subList',
    params
  })
}

///functionalarea/list
export function areaList(params) {
  return fetch({
    method: 'GET',
    url: 'functionalarea/listNoPage',
    params
  })
}

// 查询某位置下的所有智能设备
export function intellectDetail(params) {
  return fetch({
    method: 'GET',
    url: 'increase/intellectDetail',
    params
  })
}
